const Box = ({
	title,
	children,
  }: {
	title: string;
	children: React.ReactElement | string;
  }) => (
	<div className="bg-white p-4 rounded-md mb-4">
	  <h5 className="text-2xl font-bold">{title}</h5>
	  <div className="my-3">{children}</div>
	</div>
  );
  
  export default Box;